import { IntegrationSource } from '@modules/integrationsV2/types';
import { IntegrationChannelType, IntegrationType } from 'generated/graphql';

export const getCanConfigureIntegrationSourceLink = (
  integrationSource: IntegrationSource,
) => {
  if (integrationSource.integrationType !== IntegrationType.Feedback) {
    return false;
  }

  switch (integrationSource.channel.type) {
    case IntegrationChannelType.FileUpload:
    case IntegrationChannelType.Webhook:
    case IntegrationChannelType.Snowflake:
      return true;
    default:
      return false;
  }
};
